// extracted by mini-css-extract-plugin
module.exports = {"title":"categoryTitle_title__YYE81","icon":"categoryTitle_icon__8HbN1"};